// extracted by mini-css-extract-plugin
export default {"messagePopover":"messagePopoverWithTail-module__messagePopover___IAcUR","messagePopoverContent":"messagePopoverWithTail-module__messagePopoverContent___iMUse"};